/* eslint-disable */
export interface ColorData {
  /** The text's background color as a hexadecimal value. */
  background?: string;
  /** The text's foreground color as a hexadecimal value. */
  foreground?: string;
}

const baseColorData: object = {};

export const ColorData = {
  fromJSON(object: any): ColorData {
    const message = { ...baseColorData } as ColorData;
    message.background =
      object.background !== undefined && object.background !== null
        ? String(object.background)
        : undefined;
    message.foreground =
      object.foreground !== undefined && object.foreground !== null
        ? String(object.foreground)
        : undefined;
    return message;
  },

  toJSON(message: ColorData): unknown {
    const obj: any = {};
    message.background !== undefined && (obj.background = message.background);
    message.foreground !== undefined && (obj.foreground = message.foreground);
    return obj;
  },
};
